import { get } from 'lodash'
import {
  required,
  phone,
  email,
  maxLength,
  qualificationOrExperienceRequired
} from 'utils/validation'


export default function(values, props) {
  const initialPhone = get(props, 'data.assessorPhone')

  const qualificationOrExperienceCheck = qualificationOrExperienceRequired(get(values, 'assessorReportDetail.myExperience'), get(values, 'assessorReportDetail.myQualification'))

  const result = {
    assessorReportDetail: {
      lastName: required(get(values, 'assessorReportDetail.lastName')) ||
        maxLength(50)(get(values, 'assessorReportDetail.lastName')),
      assessorReport: required(
        get(values, 'assessorReportDetail.assessorReport')
      ),
      email: required(get(values, 'assessorReportDetail.email')) ||
        email(get(values, 'assessorReportDetail.email')) ||
        maxLength(512)(get(values, 'assessorReportDetail.email')),
      myExperience: qualificationOrExperienceCheck || maxLength(200)(
        get(values, 'assessorReportDetail.myExperience')
      ),
      myQualification: qualificationOrExperienceCheck || maxLength(200)(
        get(values, 'assessorReportDetail.myQualification')
      )
    },
    approved: required(get(values, 'approved'))
  }

  // Dont validate initial phone value
  if (
      (!initialPhone || initialPhone !== get(values, 'assessorReportDetail.phone')) && get(values, 'assessorReportDetail.phone') !== '+'
  ) {
    result.assessorReportDetail.phone =
      phone(get(values, 'assessorReportDetail.phone')) ||
      maxLength(100)(get(values, 'assessorReportDetail.phone'))
  }

  return result
}
